
import { User } from "firebase/auth";

export const isSuperAdmin = (user: User | null): boolean => {
  return user?.email === "nekyra@gmail.com";
};
